import { PersonalisationApi } from 'ctp-personalisation-nosql';
import { SearchApi, PersonalisationApi as PersoApi } from 'ctp-personalisation-search';
import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

const apiConfig = {
  accessToken: () => userManager.getApiKey().replace('Bearer ', '')
};

export const PersonalisationApiCaller = new PersonalisationApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export const PersoApiCaller = new PersoApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export const SearchApiCaller = new SearchApi(
  apiConfig,
  routes.apiRoutes.basePath
);
export default PersonalisationApiCaller;
